export default "__VITE_ASSET__77de2dd6__"